<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container [fluid]="true" class="">
    <!-- <button toggle="visible" cHeaderToggler [cSidebarToggle]="sidebarId" class="ps-1">
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button> -->

    <div class="header-search">
      <form class="nosubmit">
        <input
          class="nosubmit"
          type="search"
          placeholder="Search for Notification, Patient..."
        />
      </form>
    </div>

    <div class="user-prof-icon">
      <div class="d-flex align-items-center gap-2">

        <div class="dropdown-container" *ngIf="showDropDown">
          <select id="roleSelector" [(ngModel)]="selectedRole" (change)="onRoleChange($event)" style="
          border-radius: 9px;
          width: 90px;" class="custom-dropdown">
            <option *ngFor="let role of mainRoles" class="custom-option" [value]="role">{{ role }}</option>
          </select>
        </div>
        <span class="name-init" (click)="viewMemberProfile()"> <i class="fa-solid fa-user"></i> </span>
        
        
      
      </div>
      <div class="name-role">
        <span>{{ fullName }} ({{ filteredRoles.join(', ') }})</span>
      </div>
      <div *ngIf="designation" class="d-flex align-items-center gap-2">
        <span class="name-init"> <i class="fa-solid fa-sitemap"></i> </span>
        <div class="name-role">
          <span>{{ designation }}</span>
        </div>
      </div>
    

      <div class="icon-dropdown">
        <a (click)="logoutConfirmationModalReq()">
          <i class="fa-solid fa-power-off"></i>
        </a>
      </div>
      <ul class="dropdown-list" *ngIf="isDropDownActive">
        <a (click)="logoutConfirmationModalReq()">
          <li>Logout</li>
        </a>
      </ul>
    </div>

    <!-- <c-header-nav class="d-none d-lg-flex me-auto">
      <c-nav-item>
        <a cNavLink routerLink="/dashboard" routerLinkActive="active">
          Dashboard
        </a>
      </c-nav-item>
      <c-nav-item>
        <a cNavLink routerLink="/users" routerLinkActive="active">Users</a>
      </c-nav-item>
      <c-nav-item>
        <a cNavLink routerLink="/settings" routerLinkActive="active">
          Settings
        </a>
      </c-nav-item>
    </c-header-nav> -->

    <!-- <c-header-nav class="d-none d-lg-flex">
      <c-nav-item>
        <a routerLink="./" cNavLink>
          <svg cIcon name="cilBell" size="lg"></svg>
        </a>
      </c-nav-item>
      <c-nav-item>
        <a routerLink="./" cNavLink>
          <svg cIcon name="cilList" size="lg"></svg>
        </a>
      </c-nav-item>
      <c-nav-item>
        <a routerLink="./" cNavLink>
          <svg cIcon name="cilEnvelopeOpen" size="lg"></svg>
        </a>
      </c-nav-item>
    </c-header-nav>
    <c-header-nav class="ms-3">
      <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
    </c-header-nav> -->
  </c-container>
  <!-- <c-header-divider></c-header-divider> -->
  <!-- <c-container [fluid]="true">
    <c-breadcrumb-router class="ms-2"></c-breadcrumb-router>
  </c-container> -->
</ng-container>
<!--</c-header>-->

<ng-template #userDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button cButton color="" [caret]="false" cDropdownToggle class="py-0">
      <c-avatar
        cTextColor="primary"
        shape="rounded-1"
        size="md"
        src="./assets/img/avatars/8.jpg"
        status="success"
      >
      </c-avatar>
    </button>
    <ul cDropdownMenu class="pt-0 pr-5 w-auto">
      <li>
        <h6 cDropdownHeader class="bg-light fw-semibold py-2">Account</h6>
      </li>
      <li>
        <a routerLink="./" cDropdownItem>
          <svg cIcon class="me-2" name="cilBell"></svg>
          Updates
          <c-badge class="ms-2 float-end" color="info"> 42 </c-badge>
        </a>
      </li>
      <li>
        <a routerLink="./" cDropdownItem>
          <svg cIcon class="me-2" name="cilEnvelopeOpen"></svg>
          Messages
          <c-badge class="ms-2 float-end" color="success"> 42 </c-badge>
        </a>
      </li>
      <li>
        <a routerLink="./" cDropdownItem>
          <svg cIcon class="me-2" name="cilTask"></svg>
          Tasks
          <c-badge class="ms-2 float-end" color="danger"> 42 </c-badge>
        </a>
      </li>
      <li>
        <a routerLink="./" cDropdownItem>
          <svg cIcon class="me-2" name="cilCommentSquare"></svg>
          Comments
          <c-badge class="ms-auto" color="warning"> 42 </c-badge>
        </a>
      </li>
      <li>
        <h6 cDropdownHeader class="bg-light fw-semibold py-2">Settings</h6>
      </li>
      <li></li>
      <li>
        <a routerLink="./" cDropdownItem>
          <svg cIcon class="me-2" name="cilUser"></svg>
          Profile
        </a>
      </li>
      <li>
        <a routerLink="./" cDropdownItem>
          <svg cIcon class="me-2" name="cilSettings"></svg>
          Settings
        </a>
      </li>
      <li>
        <a routerLink="./" cDropdownItem>
          <svg cIcon class="me-2" name="cilCreditCard"></svg>
          Payments
          <c-badge class="ms-2 float-end" color="secondary"> 42 </c-badge>
        </a>
      </li>
      <li>
        <a routerLink="./" cDropdownItem>
          <svg cIcon class="me-2" name="cilFile"></svg>
          Projects
          <c-badge class="ms-2 float-end" color="primary"> 42 </c-badge>
        </a>
      </li>
      <li>
        <hr cDropdownDivider />
      </li>
      <li>
        <a (click)="onLogOut()" cDropdownItem>
          <svg cIcon class="me-2" name="cilLockLocked"></svg>
          Lock Account
        </a>
      </li>
      <li></li>
    </ul>
  </c-dropdown>
</ng-template>




<div class="success-modal-form" *ngIf="logoutConfirmationModal">
  <div class="animation-wrapper">
    <div class="animation-view">
      <img src="../../assets/images/logout-animation.gif" alt="" />
    </div>

    <div class="animation-text-wrapper">
      <h6>Are you sure you want to logout?</h6>

      <div class="d-flex">
        <button (click)="rejectLogoutRequest()" class="submitBtn m-2">
          No
        </button>
        <button (click)="onLogOut()" class="submitBtn m-2">
          Yes
        </button>

      </div>

    </div>
  </div>
</div>
